/**
 * 印刷モードのカスタム縮尺分母を検証する純粋関数群。
 *
 * MapExportPanel のカスタム入力欄から受け取った文字列を、出力で利用する
 * 数値（縮尺分母）に変換するロジックをここに集約する。React／Leaflet には
 * 依存しないため、ユニットテストから直接呼び出して境界値を検証できる。
 */

export const CUSTOM_SCALE_MIN = 100;
export const CUSTOM_SCALE_MAX = 50000;
export const CUSTOM_SCALE_STEP = 100;

/**
 * カスタム縮尺の分母として受け取った文字列を検証する。
 *
 * 戻り値が数値なら、その値を縮尺分母として使ってよい。null は「未入力」と
 * 「無効入力」を区別しないので、無効状態を UI で表現したい場合は呼び出し側
 * で `input.trim() !== ""` などと組み合わせて判定する。
 */
export const validateCustomScale = (input: string): number | null => {
  if (input.trim() === "") return null;
  const value = Number(input);
  if (!Number.isFinite(value)) return null;
  if (!Number.isInteger(value)) return null;
  if (value < CUSTOM_SCALE_MIN || value > CUSTOM_SCALE_MAX) return null;
  if (value % CUSTOM_SCALE_STEP !== 0) return null;
  return value;
};
